// Library methods
import { Grid, Typography } from "@mui/material";
import React, { useCallback, useMemo } from "react";

// Utilities
import styles from "./index.module.css";

const TumblingE = ({ examData }) => {
  const displayedDirections = useMemo(() => {
    const directions = examData?.state?.directions ?? [];
    return directions.flatMap((dir) =>
      dir.letters.map((char) => ({
        color:
          char?.State === "GuessedCorrectly"
            ? "#13A321"
            : char?.State === "Skipped"
              ? "#202338"
              : char?.State === "None"
                ? "#202338"
                : "#B21515",
        backgroundImage:
          char?.State === "Skipped"
            ? "linear-gradient(0deg, #E7C43C60 25%, #FFF 25%, #FFF 50%, #E7C43C60 50%, #E7C43C60 75%, #FFF 75%, #FFF 100%)"
            : "none",
        backgroundSize: "8px 8px",
        value: char?.Value,
      }))
    );
  }, [examData?.state?.directions]);

  const getDirChosen = useCallback(
    (value) =>
      value === "UP"
        ? "270deg"
        : value === "DOWN"
          ? "90deg"
          : value === "LEFT"
            ? "180deg"
            : value === "RIGHT"
              ? "0deg"
              : null,
    []
  );

  return (
    <>
      <Grid className={styles.gridContainer}>
        {displayedDirections?.length > 0 &&
          displayedDirections.map((letter, index) => {
            const value = letter?.value;
            const directionChosen = getDirChosen(value);

            return (
              <Grid
                item
                key={index}
                className={styles.gridItem}
                sx={{
                  transform: `rotate(${directionChosen})`,
                  backgroundImage: letter?.backgroundImage,
                  backgroundSize: letter?.backgroundSize,
                  display: "flex",
                  justifyContent: "center",
                  width: { xs: "40px", sm: "54px" },
                  height: { xs: "40px", sm: "54px" },
                }}
              >
                <Typography
                  variant="h5"
                  color={letter?.color}
                  fontWeight={600}
                  fontSize={{ xs: "20px", sm: "40px" }}
                >
                  E
                </Typography>
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};

export default TumblingE;
